import React, { useState, useEffect } from 'react';

const Header3HE = () => {
  const [showOverlayA, setshowOverlayA] = useState(false);
  const togglemenuA = () => {
    setshowOverlayA(prevState => !prevState);
};
useEffect(() => {
  if (showOverlayA) {
    document.documentElement.style.overflowY = 'hidden'; // Disable vertical scrolling
    document.body.style.overflowY = 'hidden'; // Ensure body scrolling is also disabled
  } else {
    document.documentElement.style.overflowY = 'auto'; // Enable vertical scrolling
    document.body.style.overflowY = 'auto'; // Ensure body scrolling is also enabled
  }

  // Cleanup function to reset the overflow property when the component unmounts
  return () => {
    document.documentElement.style.overflowY = 'auto'; // Ensure scrolling is enabled when component unmounts
    document.body.style.overflowY = 'auto'; // Ensure scrolling is also enabled on body
  };
}, [showOverlayA]);
  return (
    <>
      <div
        className="generic-container flex items-center h-full"
        style={{
          borderWidth: "0px",
          borderStyle: "solid",
          borderColor: "rgb(206, 216, 221)",
          boxSizing: "border-box",
          display: "flex",
          WebkitBoxAlign: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          maxWidth: "1050px",
          background:
            "linear-gradient(315deg, rgb(0,0,0) 0%, rgb(7, 7, 14) 20%, rgb(14, 14, 28) 40%, rgb(21, 21, 42) 60%, rgb(28, 28, 56) 80%, rgb(35, 35, 70) 100%)",
          
        }}
      >
        <div
          className="logo-container flex items-center xl:gap-4 gap-8 py-2"
          style={{
            borderWidth: "0px",
            borderStyle: "solid",
            borderColor: "rgb(206, 216, 221)",
            boxSizing: "border-box",
            WebkitBoxAlign: "center",
            alignItems: "center",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
            gap: "1rem",
            zIndex: 100,
            display: "flex",
          }}
        >
          <div
            style={{
              borderWidth: "0px",
              borderStyle: "solid",
              borderColor: "rgb(206, 216, 221)",
              boxSizing: "border-box",
            }}
          >
            <a
              className="AppHyperlink inline-flex items-center flex-wrap is-dark-variant rounded-md"
              href="/"
              rel="noopener noreferrer"
              target="_self"
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                textDecoration: "inherit",
                color: "var(--a-tag-color,inherit)",
                outlineStyle: "solid",
                outlineColor: "transparent",
                outlineOffset:
                  "calc(var(--focus-visible-outline-offset,4px) + 4px)",
                transitionProperty: "outline-color, outline-offset",
                transitionDuration: "0.2s",
                borderRadius: "0.375rem",
                flexWrap: "wrap",
                WebkitBoxAlign: "center",
                alignItems: "center",
                display: "block",
              }}
            >
              <img
                className="logo-primary-img"
                alt="EnbyBase"
                src="../enbybasefooterlogo.png"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  display: "block",
                  verticalAlign: "middle",
                  maxWidth: "100%",
                  height: "auto",
                  width: "128px",
                }}
              />
            </a>
          </div>
        </div>
        <div
          className="ml-auto md:rtl:ml-0 md:rtl:mr-auto h-full"
          style={{
            borderWidth: "0px",
            borderStyle: "solid",
            borderColor: "rgb(206, 216, 221)",
            boxSizing: "border-box",
            height: "100%",
            marginLeft: "auto",
          }}
        >
          <nav
            className="flex gap-x-4 lg:gap-x-3 h-full"
            style={{
              borderWidth: "0px",
              borderStyle: "solid",
              borderColor: "rgb(206, 216, 221)",
              boxSizing: "border-box",
              display: "flex",
              height: "100%",
              columnGap: "0.75rem",
            }}
          >
            <button
              className="btn-side-interaction"
              type="button"
              aria-label="Search"
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                margin: "0px",
                fontFamily: "inherit",
                fontSize: "100%",
                fontWeight: "inherit",
                lineHeight: "inherit",
                color: "inherit",
                textTransform: "none",
                padding: "0.25rem 0.5rem",
                appearance: "button",
                backgroundColor: "transparent",
                backgroundImage: "none",
                outlineStyle: "solid",
                outlineColor: "transparent",
                outlineOffset:
                  "calc(var(--focus-visible-outline-offset,1px) + 4px)",
                cursor: "pointer",
                borderRadius: "0px",
                borderBottom: "3px solid transparent",
                transition: "border-bottom-color 0.3s ease 0s",
                transitionDuration: "0.3s",
                transitionProperty: "border-bottom-color",
              }}
            >
              <div
                className="flex items-center"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  display: "flex",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  className="fill-current"
                  height="1.2em"
                  width="1.2em"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                    display: "block",
                    verticalAlign: "middle",
                    fill: "#FFFFFF",
                  }}
                >
                  <path
                    d="M504.1 471l-134-134C399.1 301.5 415.1 256.8 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c48.79 0 93.55-16.91 129-45.04l134 134C475.7 509.7 481.9 512 488 512s12.28-2.344 16.97-7.031C514.3 495.6 514.3 480.4 504.1 471zM48 208c0-88.22 71.78-160 160-160s160 71.78 160 160s-71.78 160-160 160S48 296.2 48 208z"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                    }}
                  />
                </svg>
                <span
                  className="text-sm ml-1 lg:hidden"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                    fontSize: "0.875rem",
                    lineHeight: "1.25rem",
                    marginLeft: "0.25rem",
                    display: "none",
                  }}
                >
                  Search
                </span>
              </div>
            </button>
            <div
              className="adb-account-container"
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                animationName: "atNodeInserted26",
                display: "flex",
                position: "relative",
                visibility: "visible",
              }}
            >
              <button
                className="btn-side-interaction"
                type="button"
                aria-label="Account"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  margin: "0px",
                  fontFamily: "inherit",
                  fontSize: "100%",
                  fontWeight: "inherit",
                  lineHeight: "inherit",
                  color: "inherit",
                  textTransform: "none",
                  padding: "0.25rem 0.5rem",
                  appearance: "button",
                  backgroundColor: "transparent",
                  backgroundImage: "none",
                  outlineStyle: "solid",
                  outlineColor: "transparent",
                  outlineOffset:
                    "calc(var(--focus-visible-outline-offset,1px) + 4px)",
                  cursor: "pointer",
                  animationName: "atNodeInserted94",
                  borderRadius: "0px",
                  borderBottom: "3px solid transparent",
                  transition: "border-bottom-color 0.3s ease 0s",
                  transitionDuration: "0.3s",
                  transitionProperty: "border-bottom-color",
                  visibility: "visible",
                }}
              ><a href="/account">
                <svg
                  className="fill-current"
                  height="1.2em"
                  width="1.2em"
                  viewBox="0 0 448 512"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                    display: "block",
                    verticalAlign: "middle",
                    fill: "#FFFFFF",
                  }}
                >
                  <path
                    d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "rgb(206, 216, 221)",
                      boxSizing: "border-box",
                    }}
                  />
                </svg></a>
              </button>
            </div>
            <button
              className="btn-side-interaction >lg:hidden"
              type="button"
              aria-label="Menu"
              onClick={togglemenuA}
              style={{
                borderWidth: "0px",
                borderStyle: "solid",
                borderColor: "rgb(206, 216, 221)",
                boxSizing: "border-box",
                margin: "0px",
                fontFamily: "inherit",
                fontSize: "100%",
                fontWeight: "inherit",
                lineHeight: "inherit",
                color: "inherit",
                textTransform: "none",
                padding: "0.25rem 0.5rem",
                appearance: "button",
                backgroundColor: "transparent",
                backgroundImage: "none",
                outlineStyle: "solid",
                outlineColor: "transparent",
                outlineOffset:
                  "calc(var(--focus-visible-outline-offset,1px) + 4px)",
                cursor: "pointer",
                borderRadius: "0px",
                borderBottom: "3px solid transparent",
                transition: "border-bottom-color 0.3s ease 0s",
                transitionDuration: "0.3s",
                transitionProperty: "border-bottom-color",
              }}
            >
              <svg
                className="fill-current"
                height="1.2em"
                width="1.2em"
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  borderWidth: "0px",
                  borderStyle: "solid",
                  borderColor: "rgb(206, 216, 221)",
                  boxSizing: "border-box",
                  display: "block",
                  verticalAlign: "middle",
                  fill: "#FFFFFF",
                }}
              >
                <path
                  d="M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z"
                  style={{
                    borderWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "rgb(206, 216, 221)",
                    boxSizing: "border-box",
                  }}
                />
              </svg>
            </button>
          </nav>
        </div>
      </div>
      {showOverlayA && (<div id='mobileoverlaymenubar' className='mobileoverlaymenubar' style={{
          position: "fixed", zIndex: 9999, width: '100%', height: '100%', backgroundColor: "rgba(35, 35, 70,1)",}}>
      
      <div
        className="mobile-menu-navigation"
        style={{
          boxSizing: "border-box",
          listStyle: "none",
          border: "0px",
          margin: "0px",
          outline: "0px",
          fontSize: "100%",
          fontStyle: "inherit",
          fontWeight: "inherit",
          verticalAlign: "baseline",
          padding: "25px 50px",
          width: "100%",
          font: "15px / 56px Rubik-Medium, sans-serif",
          lineHeight: "56px",
          maxHeight: '80vh', // Limit height to ensure scrolling works
              overflowY: 'auto', // Enable vertical scrolling on the div
              direction: 'rtl',
        }}
      >
        <li
          id="nav_menu-4"
          className="widget widget_nav_menu"
          style={{
            boxSizing: "border-box",
            listStyle: "none",
            border: "0px",
            outline: "0px",
            padding: "0px",
            fontSize: "100%",
            fontStyle: "inherit",
            fontWeight: "inherit",
            verticalAlign: "baseline",
            margin: "0px 0px 2.8em",
            marginBottom: "0px",
          }}
        >
          <nav
            className="menu-mobile-header-menuen-container"
            aria-label="Menu"
            style={{
              boxSizing: "border-box",
              listStyle: "none",
              display: "block",
            }}
          >
            <ul
              id="menu-mobile-header-menuen"
              className="menu"
              style={{
                border: "0px",
                outline: "0px",
                padding: "0px",
                fontSize: "100%",
                fontStyle: "inherit",
                fontWeight: "inherit",
                verticalAlign: "baseline",
                listStyle: "disc",
                boxSizing: "border-box",
                margin: "0px",
                marginTop: "0px",
                marginBottom: "0px",
                listStyleType: "none",
              }}
            >
              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="/articles"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                 מאמרים
                </a>
              </li>
              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/news"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                    חדשות
                </a>
              </li>
              
              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/identities"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                 זהות מגדרית
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/misc"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                     שונות
                </a>
              </li>

              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="/forums"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                     הפורומים
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/forums/thailand"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                 תאילנד
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/forums/singapore"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                     סינגפור
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/forums/korea"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                     דרום קוריאה
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/forums/israel"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                    ישראל
                </a>
              </li>

              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="https://dsc.gg/enbybase"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                  שרת דיסקורד
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/discordmods"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                     מודרטורים
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/discordbot"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  EnbyBase BOT
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/rules"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                    חוקי השרת
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/openparliament"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                   פרלמנט פתוח
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/election"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                      בחירות
                </a>
              </li>
              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="/pronounscard"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                  Pronouns Card
                </a>
              </li>
              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="/miles"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                  EMI Miles 
                </a>
              </li>
              <li
                id="menu-item-2032"
                className="menu-home menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-685 current_page_item menu-item-2032"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "10px 0px",
                  lineHeight: "normal",
                  fontSize: "20px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link"
                  aria-current="page"
                  href="/about"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(156, 89, 209,1)",
                    fontWeight: 500,
                  }}
                >
                  מי אנחנו
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/projects"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                     הפרויקטים שלנו
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  href="/partnerships"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                   שותפים
                </a>
              </li>

              <li
                id="menu-item-2033-ii"
                className="menu-donation menu-item menu-item-type-post_type menu-item-object-page menu-item-2033"
                style={{
                  boxSizing: "border-box",
                  listStyle: "none",
                  border: "0px",
                  outline: "0px",
                  padding: "0px",
                  fontStyle: "inherit",
                  fontWeight: "inherit",
                  verticalAlign: "baseline",
                  transition: "all 0.2s linear 0s",
                  margin: "7.5px 0px",
                  lineHeight: "normal",
                  fontSize: "16px",
                  width: "100%",
                  cssFloat: "left",
                }}
              >
                <a
                  className="menu-link-ii"
                  target="_blank"
                  href="https://prestige-flight.web.app/about"
                  style={{
                    boxSizing: "border-box",
                    listStyle: "none",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                    fontSize: "100%",
                    fontStyle: "inherit",
                    fontWeight: "inherit",
                    verticalAlign: "baseline",
                    transition: "all 0.2s linear 0s",
                    backgroundColor: "transparent",
                    outline: "none",
                    textDecoration: "none",
                    color: "rgba(236,236,236,1)",
                    letterSpacing: "0.35px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                   על PrestigeFlight <svg
                      className="fill-current inline-block ml-3 rtl:mr-3 text-base"
                      height="1.2em"
                      width="1.2em"
                      viewBox="0 0 448 512"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "rgb(206, 216, 221)",
                        boxSizing: "border-box",
                        verticalAlign: "middle",
                        display: "inline-block",
                        fontSize: "1rem",
                        lineHeight: "1.5rem",
                        marginLeft: "0.75rem",
                        fill: "currentcolor",
                      }}
                    >
                      <path
                        d="M280 80C266.7 80 256 69.25 256 56C256 42.75 266.7 32 280 32H424C437.3 32 448 42.75 448 56V200C448 213.3 437.3 224 424 224C410.7 224 400 213.3 400 200V113.9L200.1 312.1C191.6 322.3 176.4 322.3 167 312.1C157.7 303.6 157.7 288.4 167 279L366.1 80H280zM0 120C0 89.07 25.07 64 56 64H168C181.3 64 192 74.75 192 88C192 101.3 181.3 112 168 112H56C51.58 112 48 115.6 48 120V424C48 428.4 51.58 432 56 432H360C364.4 432 368 428.4 368 424V312C368 298.7 378.7 288 392 288C405.3 288 416 298.7 416 312V424C416 454.9 390.9 480 360 480H56C25.07 480 0 454.9 0 424V120z"
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "rgb(206, 216, 221)",
                          boxSizing: "border-box",
                        }}
                      />
                    </svg>
                </a>
              </li>

            </ul>
          </nav>
        </li>{" "}
      </div>

      </div>)}
    </>
  );
}

export default Header3HE;